import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Services
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  // Objetos Observable y Emiters
  private showLogin$ = new Subject<boolean>();

  private loginSuccess$ = new Subject<boolean>();

  constructor(
    private _httpService: HttpService
  ) { }

  emmiterShowLogin( value: boolean ): void {
    this.showLogin$.next(value);
  }

  getSubjetShowLogin(): Subject<boolean> {
    return this.showLogin$;
  }

  emmiterLoginSuccess( value: boolean ): void {
    this.loginSuccess$.next(value);
  }

  getSubjetLoginSuccess(): Subject<boolean> {
    return this.loginSuccess$;
  }

  // Servicios HTTP
  
  getSmsCode(data: any) {
    let headers = {
      'sms': 'true'
    }
    return this._httpService.httpPost(`login/codigo`, data, headers);
  }

  getCode(data: any) {
    return this._httpService.httpPost(`login/codigo`, data);
  }

  loginUser(data: any) {
    return this._httpService.httpPost(`login`, data);
  }

  registerUser(data: any){
    return this._httpService.httpPost(`registro`, data);
  }

  getAddress(userId: string) {
    let headers = {
      'dataDirecciones': 'true'
    }
    return this._httpService.httpGet(`usuarios/usuario/${userId}`, headers);
  }
  
  createAddress(data: any) {
    let headers = {
      'dataDireccion': 'true'
    }
    let userId = localStorage.getItem('uid');
    return this._httpService.httpPost(`usuarios/usuario/${userId}`, data, headers);
  }

  deleteAddress(addressId: string) {
    return this._httpService.httpDelete(`usuarios/direccion/${addressId}`);
  }

  createUserTemporary(data: any) {
    return this._httpService.httpPost(`ecommerce/usuario`, data);
  }



}
